module.exports = __webpack_public_path__ + "static/media/smart-goals@2x.a20349be.png";